import {
  REQUEST_CUSTOMERS_PENDING,
  REQUEST_CUSTOMERS_SUCCESS,
  REQUEST_CUSTOMERS_FAILED,
  GET_CUSTOMER_PROFILE,
  GET_CUSTOMER_PROFILE_ERROR,
  EDIT_CUSTOMER_PROFILE_SUCCESS,
} from "../constants/customerConstants";
import Axios from "axios";
import { API_ROOT } from "../components/utils/api-config";
import { setAlert } from "./alertAction";
let token = "Bearer " + localStorage.getItem("token");
const config = {
  headers: {
    Authorization: token,
  },
};

export const requestCustomers = (search) => (dispatch) => {
  dispatch({ type: REQUEST_CUSTOMERS_PENDING });
  Axios.get(`${API_ROOT}/customers?search=${search}`, config)
    // .then(response => response.json())
    .then((response) =>
      dispatch({ type: REQUEST_CUSTOMERS_SUCCESS, payload: response.data })
    )
    .catch((error) =>
      dispatch({ type: REQUEST_CUSTOMERS_FAILED, payload: error })
    );
};

export const getCustomerProfile = (id) => (dispatch) => {
  Axios.get(`${API_ROOT}/customers/${id}/`, config)
    .then((response) =>
      dispatch({ type: GET_CUSTOMER_PROFILE, payload: response.data })
    )
    .catch((error) =>
      dispatch({ type: GET_CUSTOMER_PROFILE_ERROR, payload: error })
    );
};
export const editCustomerProfile = (customer) => (dispatch) => {
  dispatch({ type: EDIT_CUSTOMER_PROFILE_SUCCESS, payload: customer });
  dispatch(setAlert("Customer profile changed", "success"));
};
